
import { Vue, Component } from 'vue-property-decorator';
import { GAME_COVERS, GAME_COVERS_2X, LOGO2X } from '@/config/teaser';

@Component({
  props: {
    game: String,
  },
  computed: {
    coverHref() {
      const isHighResolutionScreen = window.devicePixelRatio > 1;
      if (isHighResolutionScreen) {
        return GAME_COVERS_2X[this.$props.game];
      }
      return GAME_COVERS[this.$props.game];
    },
    logoHref() {
      return LOGO2X[this.$props.game];
    },
    description() {
      const description = this.$t(`main.${this.$props.game}`);
      return `<p>${description}</p>`;
    },
    link() {
      if (this.$props.game === 'township') {
        return `/township/lp?utm_source=organic&utm_campaign=game.playrix.com&utm_medium=game.playrix.com&utm_campaign_id=2`;
      }
      return `/${this.$props.game}/lp`;
    },
  },
})
export default class Game extends Vue {}
